import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import Countdown from "react-countdown";
import TimerIcon from "../../../icons/TimerIcon";
import ProductCardSpecialMobile from "./ProductCardSpecialMobile";
import { Link, useSearchParams } from "react-router-dom";

const SpecialProductsMobile = () => {
  const [vehcledata, setvehcledata] = useState();
  const [hour, sethours] = useState();
  const [show, setShow] = useState();
  const [compelete, setcompelete] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (searchParams.get("timer")) {
      setShow(true);
    }
  }, [searchParams]);

  async function getData(params) {
    await httpReauest("GET", "/vehicle/timer", {}, {}).then(({ data }) => {
      setvehcledata(data?.data?.vehicles);
      sethours(data?.data?.hour);
    });
  }

  const renderer = ({ hours, minutes, seconds, completed, days }) => {
    if (completed) {
      setcompelete(true);
      return (
        <small className=" text-[#fff] flex gap-2 font-[500] items-center">
          پایان مهلت فروش ویژه
          <TimerIcon />
        </small>
      );
    }
    setcompelete(false);
    return (
      <span className=" text-[#fff] flex gap-2 font-[700] items-center">
        {days}:{hours}:{minutes}:{seconds}
        <TimerIcon />
      </span>
    );
  };
  const renderer2 = ({ hours, minutes, seconds, completed, days }) => {
    if (completed) {
      setcompelete(true);

      return (
        <span className=" text-[#F42A1C] flex gap-2 font-[700] items-center">
          پایان مهلت فروش ویژه
          <img src="/time.png" alt="timeer" />
        </span>
      );
    }
    setcompelete(false);
    return (
      <span className=" text-[#F42A1C] flex gap-2 font-[700] items-center">
        {days}:{hours}:{minutes}:{seconds}
        <img src="/time.png" alt="timeer" />
      </span>
    );
  };


  if (compelete) {
    return hour && <Countdown date={new Date(hour)} renderer={renderer} />;
  }

  if (!compelete) {
    return (
      <div className="mt-7">
        {!show ? (
          <Link
            style={{
              background:
                "linear-gradient(87.61deg, #DE2F2F -6.14%, #610000 96.05%)",
            }}
            to={"/discounted"}
            className="rounded-[10px] flex justify-between items-center p-4"
          >
            <span>
              <p className="text-white text-[14px] sm:text-[16px] font-bold mb-2">
                مشاهده کامیون های زیر قیمت
              </p>
              <p className="text-white">این تخفیف ها رو از دست ندی</p>
            </span>
            {hour && <Countdown date={new Date(hour)} renderer={renderer} />}
          </Link>
        ) : (
          <div className="flex justify-between flex-wrap">
            <p className="text-[14px] sm:text-[16px] font-bold">
              کامیون های زیر قیمت
            </p>
            {hour && <Countdown date={new Date(hour)} renderer={renderer2} />}

            <div className="w-full py-0">
              {vehcledata?.map((e, i) => (
                <ProductCardSpecialMobile
                  compelete={compelete}
                  data={e}
                  key={i}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
};

export default SpecialProductsMobile;
